import React, { useEffect, useRef, useState } from 'react'
import Script from 'next/script'
import styled from 'styled-components'

const HEIGHT = "530px"
const PlaceHolderGoogle = styled.div`
  height: ${HEIGHT};
  z-index: 1;
  position: relative;
  width: 100%;
`

const GoogleContainer = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: hidden;
  height: ${HEIGHT};
`

const ElfGoogleReviews = () => {
  const [shouldLoad, setShouldLoad] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true)
          observer.disconnect()
        }
      },
      { rootMargin: '200px' }
    )
    if (containerRef.current) {
      observer.observe(containerRef.current)
    }
    return () => observer.disconnect()
  }, [])

  return (
    <>
      {shouldLoad && (
        <Script
          id="elfsight"
          src="https://apps.elfsight.com/p/platform.js"
          strategy="lazyOnload"
        />
      )}
      <PlaceHolderGoogle ref={containerRef}>
        {shouldLoad && (
          <GoogleContainer>
            <div className="elfsight-app-e01348c3-458a-462e-92c5-e890e82271e2" />
          </GoogleContainer>
        )}
      </PlaceHolderGoogle>
    </>
  )
}

export default ElfGoogleReviews
